import { lazy } from "react";
import { REHEARSAL_LOW } from "../utils/rehearsal.js";
import { EVIDENCE_LOW } from "../utils/evidenceTimeline.js";

// Add a service here after its public route works. Cards and routes use this same list.
// See docs/labs-service-directory.md for the publishing contract.
export const LAB_SERVICES = [
  {
    id: "rehearsal",
    path: "/lab/rehearsal",
    Component: lazy(() => import("../Pages/RehearsalPage.js")),
    status: "published",
    publishedAt: "2026-09-07T00:00:00+09:00",
    updatedAt: "2026-09-07T00:00:00+09:00",
    category: "돈·대금",
    name: "돈 받는 대화 리허설",
    problem: "입금일이 지났는데, 뭐라고 보내지?",
    description: "자꾸 미루는 상대에게 할 말을 3단계로 연습하고, 지급일을 묻는 문장 예시를 확인해요.",
    keywords: ["외주 대금", "작업비", "정산", "미수금", "못 받은 돈", "빌려준 돈", "보증금", "입금일", "답장", "문자", "무료 대화 리허설"],
    output: "대화 연습 + 요청 문장 예시",
    access: "가입 없이 무료 연습",
    price: `맞춤 문장은 ${REHEARSAL_LOW}로우`,
    action: "무료로 연습하기",
  },
  {
    id: "evidence",
    path: "/lab/evidence",
    Component: lazy(() => import("../Pages/EvidenceTimelinePage.js")),
    status: "published",
    publishedAt: "2026-09-26T00:00:00+09:00",
    updatedAt: "2026-09-26T00:00:00+09:00",
    category: "돈·대금",
    name: "카톡 증거 타임라인",
    problem: "대화는 긴데, 어디가 증거인지 모르겠어요.",
    description: "카톡을 붙여넣으면 돈·약속·기한이 오간 말만 시간순으로 모아요. 미리보기는 서버로 전송되지 않아요.",
    keywords: ["카톡", "카카오톡", "대화", "증거", "정리", "타임라인", "빌려준 돈", "약속", "내용증명 준비", "소송 준비", "무료 증거 정리"],
    output: "시간순 정리 + 금액·약속 집계",
    access: "가입 없이 무료",
    price: `전체 정리본은 ${EVIDENCE_LOW}로우`,
    action: "무료로 정리하기",
  },
];
